import React, { useEffect, useState } from 'react';
import { useWallet } from '../../../contexts/WalletContext';

type Transaction = {
  hash: string;
  from_address: string;
  to_address: string;
  value: string;
  block_timestamp: string;
};

type NFT = {
  name: string;
  amount: string;
  metadata: any;
};

const WalletHistory: React.FC = () => {
  const { address } = useWallet();
  const [history, setHistory] = useState<Transaction[]>([]);
  const [nativeBalance, setNativeBalance] = useState<string | null>(null);
  const [tokens, setTokens] = useState<string[]>([]);
  const [nfts, setNfts] = useState<NFT[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!address) return;

    const fetchWalletData = async () => {
      setLoading(true);
      try {
        // Fetch transactions
        const txRes = await fetch(`http://localhost:5001/api/transactions/${address}`);
        const txData = await txRes.json();
        setHistory(txData.result || []);

        // Fetch demo data (native, tokens, NFTs)
        const demoRes = await fetch(`http://localhost:5001/api/demo?address=${address}`);
        const demoData = await demoRes.json();
        setNativeBalance(demoData.native || null);
        setTokens(demoData.tokens || []);
        setNfts(demoData.nfts || []);
      } catch (error) {
        console.error('Error fetching wallet data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchWalletData();
  }, [address]);

  if (!address) {
    return <p className="p-4">Please connect your wallet to view history.</p>;
  }

  return (
    <div className="p-4 space-y-8">
      <h1 className="text-xl font-bold">Wallet History</h1>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {/* Native Balance */}
          {nativeBalance && (
            <div className="bg-white dark:bg-gray-800 p-4 rounded shadow-sm">
              <h2 className="text-lg font-semibold">Native Balance</h2>
              <p>{nativeBalance} ETH</p>
            </div>
          )}

          {/* Token Balances */}
          {tokens.length > 0 && (
            <div className="bg-white dark:bg-gray-800 p-4 rounded shadow-sm">
              <h2 className="text-lg font-semibold mb-2">Token Balances</h2>
              <ul className="list-disc ml-5">
                {tokens.map((token, i) => (
                  <li key={i}>{token}</li>
                ))}
              </ul>
            </div>
          )}

          {/* NFTs */}
          {nfts.length > 0 && (
            <div className="bg-white dark:bg-gray-800 p-4 rounded shadow-sm">
              <h2 className="text-lg font-semibold mb-2">NFTs</h2>
              <ul className="space-y-2">
                {nfts.map((nft, i) => (
                  <li key={i}>
                    <strong>{nft.name}</strong> — Amount: {nft.amount}
                    {nft.metadata && (
                      <pre className="mt-1 text-sm bg-gray-100 dark:bg-gray-700 p-2 rounded overflow-auto">
                        {JSON.stringify(nft.metadata, null, 2)}
                      </pre>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Transactions */}
          <div>
            <h2 className="text-lg font-semibold mb-2">Transactions</h2>
            {history.length === 0 ? (
              <p>No transaction history found.</p>
            ) : (
              <div className="space-y-4">
                {history.map((tx, i) => (
                  <div key={i} className="border p-3 rounded shadow-sm bg-white dark:bg-gray-800 dark:text-white">
                    <p><strong>Hash:</strong> {tx.hash}</p>
                    <p><strong>From:</strong> {tx.from_address}</p>
                    <p><strong>To:</strong> {tx.to_address}</p>
                    <p><strong>Value:</strong> {(Number(tx.value) / 1e18).toFixed(5)} ETH</p>
                    <p><strong>Date:</strong> {new Date(tx.block_timestamp).toLocaleString()}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default WalletHistory;




